<template>
  <div class="cell-name paragraph-s">
    <span>
      {{ item.name }}
    </span>

    <div v-if="!isGrading" class="d-flex align-items-center">
      <template v-if="isNative">
        <span
          v-if="item.Student"
          class="additional-text additional-text--editable"
          @click.stop="$emit('edit-student', item)"
        >
          By {{ item.Student.firstName }} {{ item.Student.lastName }}
        </span>
        <eg-button
          v-if="item.Student"
          key="edit-btn"
          type="ordinary"
          size="extra-small"
          icon-size="extra-small"
          icon="pen-edit"
          class="student-name-btn__edit"
          @click.native.stop.prevent="$emit('edit-student', item)"
        />
        <eg-button
          v-if="item.Student"
          key="detach-btn"
          type="ordinary"
          color="danger"
          size="extra-small"
          icon-size="extra-small"
          icon="close"
          class="student-name-btn__delete"
          @click.native.stop="$emit('detach-student', item)"
        />
        <eg-button
          v-if="!item.Student"
          key="add-btn"
          type="ordinary"
          size="small"
          class="add-student-btn"
          @click.native.stop="onAddStudent"
        >
          {{ $t("essays.addStudent") }}
        </eg-button>
      </template>
      <student-link
        v-else-if="item.Student"
        class="additional-text"
        :student="item.Student"
      >
        <template #prefix> By </template>
      </student-link>
      <svg
        v-if="showGrade"
        class="mx-1"
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 4 4"
        fill="none"
      >
        <circle cx="2" cy="2" r="2" fill="#6C757D" />
      </svg>
      <div v-if="showGrade" class="additional-text">Grade {{ item.grade }}</div>
    </div>
  </div>
</template>

<script>
import StudentLink from "@/components/students/student_link.vue";

export default {
  components: {
    StudentLink,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    isGrading: {
      type: Boolean,
      default: false,
    },
    showGrade: {
      type: Boolean,
      default: false,
    },
    isFailed: {
      type: Boolean,
      default: false,
    },
    isNative: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onAddStudent() {
      this.$emit("add-student", this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-name {
  max-width: 270px;
  overflow: hidden;
  white-space: normal;
  overflow-wrap: break-word;

  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    max-width: 360px;
  }

  @media (min-width: 1366px) {
    max-width: 560px;
  }

  a:not(.additional-text) {
    color: var(--Text-Body, #212529);
  }
}

.student-name-btn {
  &__edit {
    margin-left: 4px;
  }
  &__edit,
  &__delete {
    color: var(--color-text-neutral-secondary);
    ::v-deep {
      .eg-icon_size-extra-small {
        font-weight: var(--typography-font-weight-fw-600);
        font-size: 12px;
      }
    }
  }
  &__delete {
    &:hover {
      ::v-deep {
        span {
          color: var(--color-text-semantic-onError) !important;
        }
      }
    }
  }
}

.add-student-btn {
  font-size: var(--typography-font-size-fs-300);
  transition: none !important;
  height: 24px;
}

.additional-text {
  display: inline-flex;
  align-items: center;
  height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--color-text-neutral-secondary, #566370);
  font-weight: var(--typography-font-weight-fw-400, 400);

  &--editable {
    cursor: pointer;

    &:hover {
      color: var(--color-text-primary);
      text-decoration: underline;
    }
  }
}
</style>
